/*
 * Bundle per-item prices
 * Fast Bundle's widget shows each shirt at full price. This rewrites each row to
 * show the full price crossed out and the bundle-discounted price next to it.
 * Discount ratio = bundle sale price / bundle compare-at price (passed from Liquid),
 * preferring Fast Bundle's own total box when it is present.
 * If Fast Bundle changes its markup, nothing matches and the rows stay as they are.
 */
(function () {
  var root = document.getElementById('bundle-item-prices');
  if (!root) return;

  var liquidPrice = parseInt(root.dataset.price, 10);
  var liquidCompare = parseInt(root.dataset.compareAt, 10);

  function toCents(text) {
    var n = parseFloat(String(text).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function ratio() {
    var raw = document.querySelector('.rbr-total-box-rawPrice .money, .rbr-total-box-rawPrice');
    var sale = document.querySelector('.rbr-total-box-price .money, .rbr-total-box-price');
    var r = raw && toCents(raw.textContent);
    var s = sale && toCents(sale.textContent);
    if (r && s && s < r) return s / r;
    if (liquidCompare && liquidPrice && liquidPrice < liquidCompare) return liquidPrice / liquidCompare;
    return null;
  }

  function apply() {
    var k = ratio();
    if (!k) return;
    var tags = document.querySelectorAll('.rbr-sbap_item .rbr-productNamePrice__tag__container');
    tags.forEach(function (tag) {
      var money = tag.querySelector('.money:not(.bip-sale)');
      if (!money) return;
      var full = toCents(money.textContent);
      if (!full) return;
      var sale = Math.round(full * k);
      var key = full + ':' + sale;
      if (tag.dataset.bip === key) return;
      tag.dataset.bip = key;
      var old = tag.querySelector('.bip-sale');
      if (old) old.remove();
      money.classList.add('bip-full');
      var s = document.createElement('span');
      s.className = 'money bip-sale';
      s.textContent = fmt(sale);
      money.insertAdjacentElement('afterend', s);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      apply();
    }, 30);
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  schedule();
})();
